<main class="bg-black text-white min-h-screen overflow-x-hidden">

  <section class="relative min-h-[65vh] flex items-center pt-24 pb-14 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 right-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="absolute inset-0 opacity-[0.025]"
      style="background-image: linear-gradient(rgba(0,170,230,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.5) 1px, transparent 1px); background-size: 60px 60px;">
    </div>

    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="max-w-4xl">
        <div>
          <a routerLink="/products/connectiq" class="back-nav" data-aos="fade-down">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient">
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            Back
          </a>
          <p class="text-varroc-accent text-sm font-bold uppercase tracking-widest mb-3" data-aos="fade-up">ConnectIQ
          </p>
          <h1 class="hero-col font-black mb-5" data-aos="fade-up" data-aos-delay="100">
            <span class="text-varroc-accent">SecureIQ</span>
          </h1>
          <p class="text-varroc-text-gray text-lg italic leading-relaxed mb-4" data-aos="fade-up" data-aos-delay="150">
            "Building AIS-189 & AIS-190 Compliant Connected Ecosystems Through Identity, Encryption & Intelligent
            Security"
          </p>
          <p class="text-varroc-text-gray text-base leading-relaxed mb-8" data-aos="fade-up" data-aos-delay="200">
            SecureIQ empowers OEMs, mobility providers, and industrial enterprises to build secure, standards-compliant
            connected ecosystems through PKI-based device identity, certificate lifecycle management, end-to-end
            encryption, secure OTA enablement, and Zero Trust cybersecurity. Designed to support compliance with
            AIS-189, AIS-190, UNECE WP.29 (R155 & R156), ISO/SAE 21434, ISO 24089, IEC 62443, and industry best
            practices for connected vehicles and IoT, SecureIQ establishes trust from the factory floor to the cloud.
            From secure device provisioning during manufacturing to protecting millions of connected vehicles in
            operation, SecureIQ delivers trusted identity, regulatory compliance, cyber resilience, and lifecycle
            security across the entire mobility ecosystem.
          </p>
          <div class="flex flex-wrap gap-4" data-aos="fade-up" data-aos-delay="300">
            <a routerLink="/contact-us"
              class="bg-varroc-accent text-white font-bold px-8 py-4 rounded-md hover:bg-varroc-accent-hover hover:shadow-neon transition-all secureIq_talk_to_our_team_button">Talk
              to Our Team</a>
          </div>
        </div>

      </div>
    </div>
  </section>

  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id"
          class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>

  <div class="max-w-7xl mx-auto px-6 py-20 space-y-28">

    <section id="overview" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Foundation</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Built on Three Interlocking Pillars</h2>
        <p class="text-varroc-text-gray max-w-3xl">SecureIQ is built on three interlocking pillars that together
          establish end-to-end trust from the silicon layer to the cloud.</p>
      </div>
      <div class="grid md:grid-cols-3 gap-6">
        <div *ngFor="let pillar of pillars; let i = index" class="feature-card" data-aos="fade-up"
          [attr.data-aos-delay]="i * 80">
          <div class="w-12 h-12 bg-varroc-accent/15 rounded-xl flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-2xl' [class]="pillar.icon"></i>
          </div>
          <h3 class="text-white font-bold text-xl mb-3">{{ pillar.title }}</h3>
          <ul class="space-y-2">
            <li *ngFor="let point of pillar.points" class="flex items-start gap-2 text-varroc-text-gray text-sm">
              <i class='bx bx-check-circle icon-gradient mt-0.5 flex-shrink-0'></i>
              <span>{{ point }}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="capabilities" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Core Capabilities</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Comprehensive Security at Every Layer</h2>
        <p class="text-varroc-text-gray max-w-2xl">SecureIQ delivers a comprehensive set of security capabilities
          designed to address the full spectrum of connected vehicle and IoT security requirements.</p>
      </div>
      <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div *ngFor="let capability of capabilities; let i = index" class="feature-card" data-aos="fade-up"
          [attr.data-aos-delay]="i * 60">
          <div class="w-12 h-12 bg-varroc-accent/15 rounded-xl flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-2xl' [class]="capability.icon"></i>
          </div>
          <h3 class="text-white font-bold text-lg mb-2">{{ capability.title }}</h3>
          <p class="text-varroc-text-gray text-sm leading-relaxed">{{ capability.desc }}</p>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="lifecycle" class="section-anchor">
      <div class="mb-10" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Certificate Lifecycle</span>
        <h2 class="text-4xl font-black mt-3 mb-5">End-to-End Certificate Lifecycle Management</h2>
        <p class="text-varroc-text-gray leading-relaxed max-w-3xl">SecureIQ provides end-to-end management for the
          entire
          lifecycle of digital certificates, ensuring continuous trust and security across the connected ecosystem.
        </p>
      </div>
      <div class="flex justify-center mb-10" data-aos="fade-up" data-aos-delay="80">
        <img src="../../../../../assets/images/websitev2/secureiq.png" alt="SecureIQ Certificate Lifecycle"
          class="w-[90%] rounded-2xl" />
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="usecases" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Use Cases</span>
        <h2 class="text-4xl font-black mt-2 mb-4">Securing the Full Value Chain</h2>
        <p class="text-varroc-text-gray max-w-2xl">SecureIQ's PKI-driven framework addresses security requirements
          across the full connected mobility and industrial IoT value chain.</p>
      </div>
      <div class="grid md:grid-cols-2 gap-6">
        <div *ngFor="let useCase of useCases; let i = index" class="feature-card" data-aos="fade-up"
          [attr.data-aos-delay]="i * 70">
          <div class="w-12 h-12 bg-varroc-accent/15 rounded-xl flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-2xl' [class]="useCase.icon"></i>
          </div>
          <h3 class="text-white font-bold text-lg mb-3">{{ useCase.title }}</h3>
          <ul class="space-y-2">
            <li *ngFor="let point of useCase.points" class="flex items-start gap-2 text-varroc-text-gray text-sm">
              <i class='bx bx-check-circle icon-gradient mt-0.5 flex-shrink-0'></i>
              <span>{{ point }}</span>
            </li>
          </ul>
        </div>
      </div>
    </section>

  </div>
</main>